"use strict";

export default {
  inBearbeitung: "9d1bfcd5-ba9c-4d13-a7a8-8496af52bc2b",
  geprueft: "4fa08680-bc71-4e9d-84e2-5454a34bbe8c"
};
